/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { INDENT, SPACE_FILL, STACK_DIRECTION, StackView } from '@veeam/components';
import React from 'react';

import { TabBarBodyLayoutModes } from './enums';

export interface TabBarBodyLayoutProps {
    children: React.ReactNode | React.ReactElement;
    mode?: TabBarBodyLayoutModes;
}

export const TabBarBodyLayout: React.FC<TabBarBodyLayoutProps> = ({ mode = TabBarBodyLayoutModes.Normal, children }) => {
    const isScrollable = mode === TabBarBodyLayoutModes.Scrollable;

    return (
        <StackView
            direction={STACK_DIRECTION.column}
            spaceFill={SPACE_FILL.all}
            spaceBottom={INDENT.m}
            spaceRight={isScrollable ? undefined : INDENT.m}
            style={{
                overflow: isScrollable ? 'auto' : 'hidden',
            }}
        >
            {children}
        </StackView>
    );
};
